
import Vue from "vue";

export default Vue.extend({
  name: "NotFound",
  props: {
    title: {
      type: String
    },
    /** When set, Go Back navigates here (e.g. '/candidate/dashboard') instead of router.back() */
    goBackTo: {
      type: String,
      default: ""
    }
  },
  methods: {
    goBack() {
      this.$emit("go_back");
      if (this.goBackTo) {
        this.$router.push(this.goBackTo);
      } else {
        this.$router.back();
      }
    }
  }
});
